import { setDates } from './datesHelpers';
import { goToCheckInTab, goToCheckOutTab } from './index';
import { close as closeMicroModal } from './modalHandler';
import { render } from '../ScheduledPaymentsContent';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import { isShortTerm, isLongTerm } from '../../common/apartmentRentalPeriod';
import {
  format,
  daysDiff,
  SIMPLE_DATE_FORMAT,
  DATEPICKER_FORMAT
} from '../../common/dates';
import formatCurrency from '../../common/formatCurrency';
import { t } from '../../common/translations';

let payments = null;

const breakdownFirstMonthLabel = (nights, timeSpan, payInFull = false) => {
  if (!payInFull && isLongTerm(timeSpan)) return t('apartment_page.reservation_form.breakdown.first_month_rent');

  return t('apartment_page.reservation_form.breakdown.total_days_rent', { days: nights });
};

const breakdownTotalValue = (timeSpan, inAdvance = false) => {
  if (isShortTerm(timeSpan)) return t('apartment_page.reservation_form.breakdown.due_short_period_label');
  if (inAdvance) return t('apartment_page.reservation_form.breakdown.due_in_advance_label');

  return t('apartment_page.reservation_form.breakdown.due_today_label');
};

const monthlyCleaningFeeTotal = (breakdown, inAdvance = false) => {
  if (!breakdown.charging_utilities) return null;
  if (inAdvance || breakdown.time_span === 'short_term') {
    return 'R$ ' + formatCurrency(breakdown.total_monthly_cleaning_fee);
  }
  return 'R$ ' + formatCurrency(breakdown.payments[0].breakdown.cleaning_fee);
};

const breakdownOnChangeSelection = (breakdownEl, breakdownDueTodaySpanEl, breakdown) => {
  const breakdownPaymentTypeEl = document.querySelector('.breakdown-payment-type');
  const breakdownPriceValueEl = breakdownEl.querySelector('.breakdown__price .breakdown__value-amount');
  const breakdownPaymentTypesEl = breakdownEl.querySelector('.breakdown__payment-types');
  const breakdownDueTodayEl = breakdownEl.querySelector('.breakdown__due-today');
  const breakdownDueTodayValueEl = breakdownDueTodayEl.querySelector('.breakdown__value-amount');
  const breakdownFirstRentSpanEl = breakdownEl.querySelector('#first_month_label');
  const breakdownPayInAdvanceEl = breakdownEl.querySelector('#pay-in-advance');
  const breakdownPayMonthlyEl = breakdownEl.querySelector('#pay-monthly');
  const scheduledPaymentsEl = breakdownEl.querySelector('.scheduled-payments');
  const breakdownPayInAdvanceValuesEl = document.querySelector('#pay-in-advance-values');
  const breakdownPayInAdvanceValuesSubtitleValueEl = breakdownPayInAdvanceValuesEl.querySelector('.subtitle');
  const breakdownCleaningFeeValueEl = breakdownEl.querySelector('.breakdown__cleaning_fee .breakdown__value-amount');
  const breakdownCondominiumValueEl = breakdownEl.querySelector('.breakdown__condominium .breakdown__value-amount');
  const breakdownIptuValueEl = breakdownEl.querySelector('.breakdown__iptu .breakdown__value-amount');

  const breakdownPayMonthlyValuesEl = document.querySelector('#pay-monthly-values');
  const breakdownPayMonthlyValuesSubtitleValueEl = breakdownPayMonthlyValuesEl.querySelector('.subtitle');

  const payment = breakdown.payments[0];

  scheduledPaymentsEl.classList.add('scheduled-payments--hidden');
  breakdownPayMonthlyEl.classList.remove('type-item--active');

  if (isShortTerm(breakdown.time_span)) {
    breakdownPaymentTypeEl.value = 'pay_in_full';
    breakdownPaymentTypesEl.classList.add('breakdown__payment-types--hidden');
    breakdownDueTodayEl.classList.remove('breakdown__due-today--in-advance');
    breakdownIptuValueEl.innerText = 'R$ ' + formatCurrency(breakdown.total_iptu);
    breakdownCondominiumValueEl.innerText = 'R$ ' + formatCurrency(breakdown.total_condominium);
    breakdownDueTodayValueEl.innerText = `R$ ${formatCurrency(breakdown.total_w_discount)}`;
    breakdownPriceValueEl.innerText = `R$ ${(breakdown.condominium_price || breakdown.total_condominium) ? formatCurrency(breakdown.total_only_rent) : formatCurrency(breakdown.total_rent)}`;
    breakdownFirstRentSpanEl.innerText = breakdownFirstMonthLabel(breakdown.nights, breakdown.time_span);
    return;
  }

  breakdownPaymentTypeEl.value = 'pay_in_full';
  breakdownPayInAdvanceEl.classList.add('type-item--active');
  breakdownDueTodayEl.classList.add('breakdown__due-today--in-advance');
  breakdownPaymentTypesEl.classList.remove('breakdown__payment-types--hidden');
  breakdownDueTodayValueEl.innerText = `R$ ${formatCurrency(breakdown.total_w_discount)}`;
  breakdownPriceValueEl.innerText = `R$ ${(breakdown.condominium_price || breakdown.total_condominium) ? formatCurrency(breakdown.total_only_rent) : formatCurrency(breakdown.total_rent)}`;
  breakdownFirstRentSpanEl.innerText = breakdownFirstMonthLabel(breakdown.nights, breakdown.time_span, true);
  breakdownCondominiumValueEl.innerText = 'R$ ' + formatCurrency(breakdown.total_condominium);
  breakdownIptuValueEl.innerText = 'R$ ' + formatCurrency(breakdown.total_iptu);

  breakdownPayInAdvanceEl.addEventListener('click', () => {
    breakdownPaymentTypeEl.value = 'pay_in_full';
    breakdownPayInAdvanceEl.classList.add('type-item--active');
    breakdownPayMonthlyEl.classList.remove('type-item--active');
    breakdownDueTodayEl.classList.add('breakdown__due-today--in-advance');
    scheduledPaymentsEl.classList.add('scheduled-payments--hidden');
    breakdownPriceValueEl.innerText = `R$ ${(breakdown.condominium_price || breakdown.total_condominium) ? formatCurrency(breakdown.total_only_rent) : formatCurrency(breakdown.total_rent)}`;
    breakdownDueTodaySpanEl.innerText = breakdownTotalValue(breakdown.time_span, true);
    breakdownCleaningFeeValueEl.innerText = monthlyCleaningFeeTotal(breakdown, true);
    breakdownFirstRentSpanEl.innerText = breakdownFirstMonthLabel(breakdown.nights, breakdown.time_span, true);
    breakdownCondominiumValueEl.innerText = 'R$ ' + formatCurrency(breakdown.total_condominium);
    breakdownIptuValueEl.innerText = 'R$ ' + formatCurrency(breakdown.total_iptu);
    const breakdownPayInAdvanceValuesSubtitleNumericValue = parseInt(breakdownPayInAdvanceValuesSubtitleValueEl.innerText.replace(/[^\d]/g, ''), 10);

    breakdownDueTodayValueEl.innerText = `R$ ${formatCurrency(breakdownPayInAdvanceValuesSubtitleNumericValue)}`;
  });

  breakdownPayMonthlyEl.addEventListener('click', () => {
    breakdownPaymentTypeEl.value = 'first_payment';

    breakdownPayInAdvanceEl.classList.remove('type-item--active');
    breakdownPayMonthlyEl.classList.add('type-item--active');
    breakdownDueTodayEl.classList.remove('breakdown__due-today--in-advance');
    scheduledPaymentsEl.classList.remove('scheduled-payments--hidden');
    breakdownPriceValueEl.innerText = `R$ ${breakdown.condominium_price ? formatCurrency(breakdown.payments[0].breakdown.only_rent) : formatCurrency(payment.breakdown.rent)}`;
    breakdownDueTodaySpanEl.innerText = breakdownTotalValue(breakdown.time_span);
    breakdownFirstRentSpanEl.innerText = breakdownFirstMonthLabel(breakdown.nights, breakdown.time_span);
    breakdownCleaningFeeValueEl.innerText = monthlyCleaningFeeTotal(breakdown);
    const breakdownPayMonthlyLabelsSubtitleNumericValue = parseInt(breakdownPayMonthlyValuesSubtitleValueEl.innerText.replace(/[^\d]/g, ''), 10);
    breakdownCondominiumValueEl.innerText = 'R$ ' + formatCurrency(breakdown.condominium_price);
    breakdownIptuValueEl.innerText = 'R$ ' + formatCurrency(breakdown.iptu_price);

    breakdownDueTodayValueEl.innerText = `R$ ${formatCurrency(breakdownPayMonthlyLabelsSubtitleNumericValue)}`;
  });

  const willMovingWithPetCheckBoxEl = document.querySelector('#will-moving-with-pet');
  const breakdownMobileEl = document.querySelector('#preview_modal_body');
  const breakdownPetFeeValueEl = breakdownMobileEl.querySelector('.breakdown__pet_fee .breakdown__value-amount');

  willMovingWithPetCheckBoxEl.addEventListener('change', (event) => {
    const numericPetFeeValue = parseInt(breakdownPetFeeValueEl.innerText.replace(/[^\d]/g, ''), 10);
    if (event.target.checked) {
      payment.breakdown.pet_fee = numericPetFeeValue;
      payment.total = payment.total + numericPetFeeValue;
    } else {
      delete payment.breakdown.pet_fee;
      payment.total = payment.total - numericPetFeeValue;
    }
  });
};

const breakdownChangeValues = (breakdownEl, breakdown) => {
  if (isShortTerm(breakdown.time_span)) return;

  const payment = breakdown.payments[0];

  const breakdownPayInAdvanceLabelsEl = breakdownEl.querySelector('#pay-in-advance-labels');
  const breakdownPayInAdvanceLabelsSubtitleValueEl = breakdownPayInAdvanceLabelsEl.querySelector('.subtitle');

  const breakdownPayInAdvanceValuesEl = breakdownEl.querySelector('#pay-in-advance-values');
  const breakdownPayInAdvanceValuesTitleValueEl = breakdownPayInAdvanceValuesEl.querySelector('.title');
  const breakdownPayInAdvanceValuesDiscountTitleValueEl = breakdownPayInAdvanceValuesEl.querySelector('.discount-title');
  const breakdownPayInAdvanceValuesSubtitleValueEl = breakdownPayInAdvanceValuesEl.querySelector('.subtitle');

  const breakdownPayMonthlyLabelsEl = breakdownEl.querySelector('#pay-monthly-labels');
  const breakdownPayMonthlyLabelsSubtitleValueEl = breakdownPayMonthlyLabelsEl.querySelector('.subtitle');

  const breakdownPayMonthlyValuesEl = breakdownEl.querySelector('#pay-monthly-values');
  const breakdownPayMonthlyValuesTitleValueEl = breakdownPayMonthlyValuesEl.querySelector('.title');
  const breakdownPayMonthlyValuesSubtitleValueEl = breakdownPayMonthlyValuesEl.querySelector('.subtitle');

  breakdownPayInAdvanceLabelsSubtitleValueEl.innerText = breakdown.discount_percent && breakdown.discount_percent > 0 ? `${t('apartment_page.reservation_form.breakdown.save_discount', { discount: breakdown.discount_percent })}` : '';

  breakdownPayInAdvanceValuesTitleValueEl.innerText = `R$ ${formatCurrency(breakdown.monthly_rent_with_discount_w_cleaning_fee)}${t('apartment_page.reservation_form.breakdown_per_month')}`;
  breakdownPayInAdvanceValuesDiscountTitleValueEl.innerHTML = breakdown.discount_percent && breakdown.discount_percent > 0 ? `R$ ${formatCurrency(breakdown.monthly_rent_w_cleaning_fee)}${t('apartment_page.reservation_form.breakdown_per_month')}` : '';
  breakdownPayInAdvanceValuesSubtitleValueEl.innerText = `Total R$ ${formatCurrency(breakdown.total_w_discount)}`;

  breakdownPayMonthlyLabelsSubtitleValueEl.innerHTML = breakdown.discount_percent && breakdown.discount_percent > 0 ? t('apartment_page.reservation_form.breakdown.no_discount') : '';

  breakdownPayMonthlyValuesTitleValueEl.innerText = `R$ ${formatCurrency(breakdown.monthly_rent_w_cleaning_fee)}${t('apartment_page.reservation_form.breakdown_per_month')}`;
  breakdownPayMonthlyValuesSubtitleValueEl.innerHTML = `${t('apartment_page.reservation_form.breakdown.due_today_label')} R$ ${formatCurrency(payment.total)}`;
};

export async function updateMobilePreview(startDate, endDate, http, sumPetFee) {
  const breakdownMobileEl = document.querySelector('#preview_modal_body');
  const breakdownDepositLineEl = breakdownMobileEl.querySelector('.breakdown__line.breakdown__deposit');
  const breakdownDepositValueEl = breakdownMobileEl.querySelector('.breakdown__deposit .breakdown__value-amount');
  const breakdownCleaningFeeLineEl = breakdownMobileEl.querySelector('.breakdown__line.breakdown__cleaning_fee');
  const breakdownCleaningFeeTooltip = breakdownMobileEl.querySelector('.cleaning-fee-tooltip');
  const breakdownCleaningFeeValueEl = breakdownMobileEl.querySelector('.breakdown__cleaning_fee .breakdown__value-amount');
  const breakdownFinalCleaningFeeLineEl = breakdownMobileEl.querySelector('.breakdown__line.breakdown__final_cleaning_fee');
  const breakdownFinalCleaningFeeValueEl = breakdownMobileEl.querySelector('.breakdown__final_cleaning_fee .breakdown__value-amount');
  const breakdownDueTodaySpanEl = breakdownMobileEl.querySelector('#due-today-label');
  const breakdownCloseModalButtonEl = breakdownMobileEl.querySelector('.breakdown__header-close-modal');
  const scheduledPaymentsButtonEl = breakdownMobileEl.querySelector('.scheduled-payments__button-mobile');
  const breakdownPetFeeValueEl = breakdownMobileEl.querySelector('.breakdown__pet_fee .breakdown__value-amount');
  const breakdownPetFeeLineEl = breakdownMobileEl.querySelector('.breakdown__line.breakdown__pet_fee');
  const breakdownPetFeeLabel = breakdownPetFeeLineEl.querySelector('.breakdown__label > span:first-child');
  const breakdownFireInsuranceValueEl = breakdownMobileEl.querySelector('.breakdown__fire_insurance .breakdown__value-amount');
  const breakdownCondominiumEl = breakdownMobileEl.querySelector('#condominium');
  const breakdownIptuEl = breakdownMobileEl.querySelector('#iptu');
  const willMovingWithPetContainer = document.querySelector('#moving-with-pet-check-box-container');
  const willMovingWithPetCheckBoxEl = document.querySelector('#will-moving-with-pet');
  const isMovingWithPet = document.querySelector('#reservation-form #is_moving_with_pet');
  isMovingWithPet.value = 'false';
  breakdownPetFeeLabel.style.color = '#ACAEAF';
  breakdownPetFeeValueEl.style.color = '#ACAEAF';

  if (sumPetFee) {
    willMovingWithPetCheckBoxEl.addEventListener('change', (event) => {
      const breakdownDueTodayEl = document.querySelector('.breakdown__due-today');
      const breakdownDueTodayValueEl = breakdownDueTodayEl.querySelector('.breakdown__value-amount');
      const numericTotal = parseInt(breakdownDueTodayValueEl.innerText.replace(/[^\d]/g, ''), 10);
      const numericPetFeeValue = parseInt(breakdownPetFeeValueEl.innerText.replace(/[^\d]/g, ''), 10);

      const breakdownPayInAdvanceValuesEl = document.querySelector('#pay-in-advance-values');
      const breakdownPayInAdvanceValuesSubtitleValueEl = breakdownPayInAdvanceValuesEl.querySelector('.subtitle');
      const breakdownPayInAdvanceValuesSubtitleNumericValue = parseInt(breakdownPayInAdvanceValuesSubtitleValueEl.innerText.replace(/[^\d]/g, ''), 10);

      const breakdownPayMonthlyValuesEl = document.querySelector('#pay-monthly-values');
      const breakdownPayMonthlyValuesSubtitleValueEl = breakdownPayMonthlyValuesEl.querySelector('.subtitle');
      const breakdownPayMonthlyLabelsSubtitleNumericValue = parseInt(breakdownPayMonthlyValuesSubtitleValueEl.innerText.replace(/[^\d]/g, ''), 10);

      if (event.target.checked) {
        isMovingWithPet.value = 'true';
        breakdownPetFeeLabel.style.color = '#292D32';
        breakdownPetFeeValueEl.style.color = '#292D32';
        breakdownDueTodayValueEl.innerText = `R$ ${formatCurrency(numericTotal + numericPetFeeValue)}`;
        breakdownPayInAdvanceValuesSubtitleValueEl.innerText = `Total R$ ${formatCurrency(breakdownPayInAdvanceValuesSubtitleNumericValue + numericPetFeeValue)}`;
        breakdownPayMonthlyValuesSubtitleValueEl.innerText = `${t('apartment_page.reservation_form.breakdown.due_today_label')} R$ ${formatCurrency(breakdownPayMonthlyLabelsSubtitleNumericValue + numericPetFeeValue)}`;
      } else {
        isMovingWithPet.value = 'false';
        breakdownPetFeeLabel.style.color = '#ACAEAF';
        breakdownPetFeeValueEl.style.color = '#ACAEAF';
        breakdownDueTodayValueEl.innerText = `R$ ${formatCurrency(numericTotal - numericPetFeeValue)}`;
        breakdownPayInAdvanceValuesSubtitleValueEl.innerText = `Total R$ ${formatCurrency(breakdownPayInAdvanceValuesSubtitleNumericValue - numericPetFeeValue)}`;
        breakdownPayMonthlyValuesSubtitleValueEl.innerText = `${t('apartment_page.reservation_form.breakdown.due_today_label')} R$ ${formatCurrency(breakdownPayMonthlyLabelsSubtitleNumericValue - numericPetFeeValue)}`;
      }
    });
  }

  breakdownCloseModalButtonEl.addEventListener('click', closeMicroModal);

  const submitButtonEl = breakdownMobileEl.querySelector('#reservation-form-mobile__submit');
  submitButtonEl.addEventListener('click', submitForm);

  const requestAutoSubmitButtonTrigger = document.querySelector('.reservation-sticky-request-submit-trigger');
  if (requestAutoSubmitButtonTrigger.innerHTML === 'true') {
    submitButtonEl.click();
  }

  const checkInAndOutEl = breakdownMobileEl.querySelector('.dates-chosen');
  checkInAndOutEl.addEventListener('click', goToCheckInTab);
  const checkInPreviewEl = breakdownMobileEl.querySelector('.date__span-ini_date');
  checkInPreviewEl.addEventListener('click', goToCheckInTab);
  const checkOutPreviewEl = breakdownMobileEl.querySelector('.date__span-end_date');
  checkOutPreviewEl.addEventListener('click', (e) => {
    e.stopPropagation();
    goToCheckOutTab();
  });
  const breakdownPropsEl = document.querySelector('#breakdown-props');
  const propertyAvailable = breakdownPropsEl.getAttribute('data-available');
  const propertyPrice = breakdownPropsEl.getAttribute('data-price') || '0';
  const propertyHasOriginalPrice = breakdownPropsEl.getAttribute('data-has-original-price');
  const propertyOriginalPrice = breakdownPropsEl.getAttribute('data-original-price');
  const previewUrl = breakdownPropsEl.getAttribute('data-preview-url');

  setDates(startDate, endDate);

  breakdownMobileEl.querySelector('.property-available').innerText = propertyAvailable;
  if (propertyHasOriginalPrice === 'true' && (parseInt(propertyOriginalPrice.replace(/\D+/g, '')) > parseInt(propertyPrice.replace(/\D+/g, '')))) {
    breakdownMobileEl.querySelector('.monthly-original-price').innerHTML = `${propertyOriginalPrice}<span class="monthly-original-price__period">${t('apartment_page.reservation_form.breakdown_per_month')}</span>`;
  }
  breakdownMobileEl.querySelector('.monthly-price').innerText = propertyPrice;
  breakdownMobileEl.querySelector('.date__span-ini_date').innerText = format(startDate, DATEPICKER_FORMAT);
  breakdownMobileEl.querySelector('.date__span-end_date').innerText = format(endDate, DATEPICKER_FORMAT);
  breakdownMobileEl.querySelector('.breakdown__title-days').innerText = `${t('apartment_page.reservation_form.breakdown.total_days', { days: daysDiff(startDate, endDate) })}`;

  const input = {
    start_date: format(startDate, SIMPLE_DATE_FORMAT),
    end_date: format(endDate, SIMPLE_DATE_FORMAT)
  };
  scheduledPaymentsButtonEl.removeEventListener('click', handleScheduledPaymentsButton);

  const { data } = await http.get(previewUrl, {
    params: input
  });

  const { breakdown, pet_friendly: petFriendly } = data;
  payments = breakdown.payments;
  const monthlyRent = 'R$ ' + formatCurrency(breakdown.monthly_rent_with_discount);

  const firstPayment = payments[0];
  const firstPaymentBreakdown = firstPayment.breakdown;

  breakdownOnChangeSelection(breakdownMobileEl, breakdownDueTodaySpanEl, breakdown);
  breakdownChangeValues(breakdownMobileEl, breakdown);

  // updateBreakdown;
  if (propertyHasOriginalPrice === 'true' && (parseInt(propertyOriginalPrice.replace(/\D+/g, '')) > parseInt(monthlyRent.replace(/\D+/g, '')))) {
    breakdownMobileEl.querySelector('.monthly-original-price').innerHTML = `${propertyOriginalPrice}<span class="monthly-original-price__period">${t('apartment_page.reservation_form.breakdown_per_month')}</span>`;
  } else {
    breakdownMobileEl.querySelector('.monthly-original-price').innerHTML = '';
  }
  breakdownMobileEl.querySelector('.monthly-price').innerText = monthlyRent;

  breakdownDueTodaySpanEl.innerText = breakdownTotalValue(breakdown.time_span, true);

  if (firstPaymentBreakdown.long_term_discount < 0) {
    // show/hide
    breakdownMobileEl.querySelector('.breakdown__long_term_discount').style.display = 'flex';
    breakdownMobileEl.querySelector('.breakdown__long_term_discount .breakdown__value-amount').innerText = '-R$ ' + formatCurrency(-1 * firstPaymentBreakdown.long_term_discount);
  } else {
    breakdownMobileEl.querySelector('.breakdown__long_term_discount').style.display = 'none';
  }

  breakdownDepositLineEl.style.display = firstPaymentBreakdown.deposit_amount === undefined ? 'none' : 'flex';
  breakdownDepositValueEl.innerText = 'R$ ' + formatCurrency(firstPaymentBreakdown.deposit_amount);

  breakdownCleaningFeeLineEl.style.display = !data.breakdown.total_monthly_cleaning_fee || data.breakdown.total_monthly_cleaning_fee === 0 ? 'none' : 'flex';
  const tooltipCleaning = !data.breakdown.total_monthly_cleaning_fee || data.breakdown.total_monthly_cleaning_fee === 0 ? '' : t('breakdown.tooltip.utilities');
  breakdownCleaningFeeTooltip.setAttribute('data-tippy-content', tooltipCleaning);

  // TODO: move to helpers.js // decorators
  breakdownCleaningFeeValueEl.innerText = monthlyCleaningFeeTotal(breakdown, true);

  breakdownFinalCleaningFeeLineEl.style.display = firstPaymentBreakdown.final_cleaning_fee === undefined ? 'none' : 'flex';
  breakdownFinalCleaningFeeValueEl.innerText = 'R$ ' + formatCurrency(firstPaymentBreakdown.final_cleaning_fee);

  scheduledPaymentsButtonEl.addEventListener('click', handleScheduledPaymentsButton);

  tippy('[data-tippy-content]');
  document.querySelector('#dates_modal_body').classList.add('display-none');
  breakdownMobileEl.classList.remove('display-none');

  willMovingWithPetContainer.style.display = petFriendly ? 'flex' : 'none';
  breakdownPetFeeLineEl.style.display = petFriendly ? 'flex' : 'none';
  breakdownPetFeeValueEl.innerText = 'R$ ' + formatCurrency(breakdown.pet_fee);

  breakdownFireInsuranceValueEl.innerText = 'R$ ' + formatCurrency(breakdown.fire_insurance);

  if (!breakdown.condominium_price) {
    breakdownCondominiumEl.style.display = 'none';
  }

  if (!breakdown.iptu_price) {
    breakdownIptuEl.style.display = 'none';
  }
}

const handleScheduledPaymentsButton = () => {
  render(payments);
};

const submitForm = () => {
  document.querySelector('.reservation-form').style.display = 'block';
  document.querySelector('#reservation-form__submit').click();
};
